import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    HostListener,
    OnDestroy,
    OnInit,
} from "@angular/core";
import {
    MatDialog,
} from "@angular/material/dialog";
import { Title } from "@angular/platform-browser";
import {
    ActivatedRoute,
    Event as RouterEvent,
    NavigationCancel,
    NavigationEnd,
    NavigationError,
    NavigationStart,
    Router,
} from "@angular/router";
import { interval, Subscription } from "rxjs";
import { take, tap } from "rxjs/operators";
import Swal from "sweetalert2";
import { TranslateService } from "@ngx-translate/core";
import { gameBallInit } from "./gameball";
import { AddEditPhoneAndVerifyComponent } from "./Pages/Checkout/add-edit-phone-and-verify/add-edit-phone-and-verify.component";
import { AccountSettingService } from "./Services/account-setting.service";
import { EmbryoService } from "./Services/Embryo.service";
import { HomePageService } from "./Services/home-page.service";
import { LoginUsersService } from "./Services/login-users.service";
import { ReactivityService } from "./Services/reactivity.service";
import { StaticPagesService } from "./Services/static-pages.service";
import { WalletHistoryService } from "./Services/wallet-history.service";
import { MarketingService } from "./Services/marketing.service";
import { MetaService } from "./Services/meta-data.service";
import { environment } from "src/environments/environment.prod";
import { OrderRateComponent } from "./Global/order-rate/order-rate.component";
import { ViewAdsPopupComponent } from "./Global/home-sections/view-ads-popup/view-ads-popup.component";
import { CheckoutService } from "./Services/checkout.service";

export let browserRefresh = false;
declare let GbSdk: any;
declare global {
    interface Window {
        dataLayer: any[];
        google: any;
        FB: any;
        fbAsyncInit: any;
    }
}

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
    isShown: boolean = true;
    android: boolean = false;
    Categories: Array<any>;
    menuItems: any = {};
    current_source: any;
    gmloading = false;
    timer = 0;
    isRtl = "ltr";
    paymentSidenavOpen = true;
    lang: string = localStorage.getItem('lang') ? localStorage.getItem('lang') as string : "en";
    loading: boolean = false;
    loadingRoute = false;
    showBackToTop: boolean = false;
    productList = [];
    compareList = [];
    subscription: Subscription;
    canCloneGuestData: boolean = false;
    initilaizeData: any;
    firstTime: boolean = false;
    fakeArray = new Array(8);
    configValue: any;
    referral: any;
    skip_maintenance = false;
    loadingData: boolean = false;
    scriptsAlreadyRan: boolean = false;
    user: any = JSON.parse(localStorage.getItem("auth_user_crocs") || "{}");
    cartItems: any;
    utm_campaign: any;
    clickedItem: boolean = false;
    show_both_source = false;
    branches: any = [];
    branch_id: any;
    loadingBranches = true;
    loadingSpinner = false;
    hideMultiStoresArea = false;
    submittingBranch = false;
    orderRate = 0;
    driverRate = 0;
    showOrderRate: boolean = true;
    hideHeaderFooter: boolean = false;
    //  private showPerformancePopupSubscription!: Subscription;
    //  PerformancePopupValue: boolean = true;
    homePageDataCustomAds: any;
    hasStaticPage: boolean = false;
    staticPageList = [
        'privacy-policy'
    ]
    constructor(
        public embryoService: EmbryoService,
        private router: Router,
        private reactivityService: ReactivityService,
        private translate: TranslateService,
        private title: Title,
        private homePageService: HomePageService,
        private auth: LoginUsersService,
        public dialog: MatDialog,
        private route: ActivatedRoute,
        private account: AccountSettingService,
        private settingsServ: StaticPagesService,
        private walletHistoryService: WalletHistoryService,
        private marketingService: MarketingService,
        private metaService: MetaService,
        private cdRef: ChangeDetectorRef,
        private checkoutService : CheckoutService
    ) {
        // this.PerformancePopupValue = this.embryoService.showPerformancePopup;
          // this.showPerformancePopupSubscription = this.embryoService.showPerformancePopup.subscribe(value => {
          //   this.PerformancePopupValue = value;
          // });
        subscription: Subscription;
        this.subscription = router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                browserRefresh = !router.navigated;
                 const pageName:any = event.url.split('/').pop()
                 this.hasStaticPage = this.staticPageList.includes(pageName);
                 !this.hasStaticPage ? this.setPickupSource(): null;
             }
        });

        this.route.queryParams.subscribe((params) => {
            if (params) {
                if (params.af_id) {
                  let wafferx_params = params;
                  localStorage.setItem(
                    'wafferx_params',
                    JSON.stringify(wafferx_params)
                  );
                }
                if (
                    params.skip_maintenance == 1 ||
                    localStorage.getItem("skip_maintenance")
                ) {
                    this.skip_maintenance = true;
                    localStorage.setItem("skip_maintenance", "1");
                }
                if (params.token && !this.router.url.includes("verifyEmail")) {
                    this.auth.setToken(params.token);
                }
                if (params.referral) {
                    this.walletHistoryService
                        .getHistoryLinks(params.referral)
                        .subscribe();
                }
                if (params.referral && this.auth.isGuest()) {
                    localStorage.setItem("referral", params.referral);
                    this.referral = params.referral;
                }
                if (
                    (params["hide_header_footer"] &&
                        params["hide_header_footer"] == 1) ||
                    window.location.href.includes("/pdf/")
                ) {
                    this.hideHeaderFooter = true;
                }
            }
        });
        const isSafari = /^((?!chrome|android).)*safari/i.test(
            navigator.userAgent
        );

        // this.router.navigate([this.router.url]);
        if (localStorage.getItem("environmentVariables")) {
            this.settingsServ.setenvConfig(
                JSON.parse(localStorage.getItem("environmentVariables") || "{}")
            );
        }
        auth.getUserDataEmit().subscribe((user) => {
            if (user) {
                this.user = user;
                if (this.user.branch) {
                    this.branch_id = this.user.branch.id;
                }

                this.setPickupSource();
                if (
                    this.configValue?.PICKUP_DELIVERY_SOURCE_Backup == "both" &&
                    (this.user?.show_branch_input || this.user?.show_area_input)
                ) {
                    this.backToBoth();
                }
                if (this.user?.logged) {
                    this.current_source = null;
                    this.user.logged = false;
                    this.configValue.PICKUP_DELIVERY_SOURCE =
                        this.configValue.PICKUP_DELIVERY_SOURCE_Backup;
                    if (!this.user.branch && !this.user.area) {
                        this.resetSource();
                    }
                }
            } else if (!user && this.configValue?.ENABLE_MULTI_INVENTORY) {
                this.current_source = null;
                this.resetSource();
            }
        });

        if (isSafari) {
            setTimeout(() => {
                this.getConfigration();
            }, 300); // Safari
        } else {
            this.getConfigration();
        }
        this.Categories = [];
        translate.addLangs(["en", "ar"]);
        translate.setDefaultLang(this.lang as string);
        translate.use(this.lang as string);
        this.subscription = this.reactivityService.storeObserver$.subscribe(
            (data: any) => {}
        );
        if (navigator?.userAgent?.match(/Android/i)) this.android = true;

        this.homePageService.getHomeCustomAdsData().subscribe({
            next: (rep) => {
                this.homePageDataCustomAds = rep.data;
            },
        });
    }
 
    resetSource() {
        this.configValue.PICKUP_DELIVERY_SOURCE =
            this.configValue.PICKUP_DELIVERY_SOURCE_Backup;

        if (this.configValue?.PICKUP_DELIVERY_SOURCE_Backup == "both") {
            this.show_both_source = true;
        }
    }

    setSource(source: any) {
        if (this.user) {
            this.user.show_branch_input = false;
            this.user.show_area_input = false;
            if (source == "store") {
                this.user.show_branch_input = true;
            }
            if (source == "area") {
                this.user.show_area_input = true;
            }
        }
        this.show_both_source = false;
        this.current_source = source;
        this.configValue.PICKUP_DELIVERY_SOURCE = source;
        this.setconfig(this.configValue);
        if (this.configValue?.PICKUP_DELIVERY_SOURCE == "store") {
            this.getAllStores();
        }
    }

    submitBranch() {
        this.homePageService
            .setStore({ branch_id: this.branch_id })
            .subscribe((res: any) => {
                if (res.data) {
                    this.getHeaderList(true);
                    this.submittingBranch = false;
                    this.user = res.data;
                    setTimeout(() => {
                    this.auth.setUserDataEmit(this.user);
                    this.getDynamicMenuData();

                    }, 1000);
                    this.auth.setBranchDataEmit(true);
                    this.submittingBranch = true;
                    // this.PerformancePopupValue = false;
                }
            });
    }

    getAllStores() {
        this.loadingBranches = true;
        this.branches = [];
        this.homePageService.getAllStores().subscribe((res) => {
            this.branches = res.data;
            if (this.branches?.length > 0 && !this.user.branch) {
                this.branch_id = this.branches[0].id;
            }
            this.loadingBranches = false;
        });
    }

    setPickupSource() {
        if (this.configValue?.PICKUP_DELIVERY_SOURCE == "both" && !this.hasStaticPage) {
            if (this.user && this.user.branch) {
                this.configValue.PICKUP_DELIVERY_SOURCE = "store";
                this.show_both_source = false;
            } else if (this.user && this.user.area) {
                this.configValue.PICKUP_DELIVERY_SOURCE = "area";
                this.show_both_source = false;
            } else {
                this.show_both_source = true;
            }
        }
    }

    getOrderById(id:any){
        this.checkoutService.getOrderById(id).subscribe((res:any) =>{
            if(res.code == 200){
                this.openRate(res.data)
            }
        })
    }
    openRate(order: any) {
        if (this.dialog.openDialogs && this.dialog.openDialogs.length > 0) {
            return false;
        }        
        let dialogRef = this.dialog
            .open(OrderRateComponent, {
                // data: orderId,
                data: {
                    id: order.id,
                    rate: 0,
                    driver_rate: 0,
                    feedback: "",
                    showSkip: true,
                    showExit: false,
                    orderId: order.id,
                    items:order.items
                },
                width: "500px",
                disableClose: true,
            })
            .afterClosed()
            .subscribe((result: any) => {
                if (result !== undefined) {
                    // this.order = result;
                }
            });
    }

    ngOnInit() {
        this.embryoService.productCartSub.subscribe((res) => {
            if (res) {
                this.cartItems = res;
            }
        });
        this.router.events.subscribe((event) => {
          
            this.navigationInterceptor(event);
            if (event instanceof NavigationEnd) {
                if(this.router.url.includes('checkout')){
                  this.embryoService.sendPaymentPAgeStatus(true)
                }else{
                  this.embryoService.sendPaymentPAgeStatus(false)
                }
                this.marketingService.fbTracking("track", "PageView");
                this.marketingService.fbTracking("track", "ViewContent");
                this.marketingService.snapTracking("track", "PAGE_VIEW");
                this.marketingService.snapTracking("track", "VIEW_CONTENT");
                if (this.configValue?.GOOGLE_CONVERSION_ID) {
                    this.marketingService.googleConversionTracking(
                        "conversion",
                        this.configValue?.GOOGLE_CONVERSION_ID,
                        this.configValue?.GOOGLE_CONVERSION_LABEL,
                        this.configValue?.GOOGLE_CONVERSION_TRANSACTION_ID
                    );
                }

                this.settingsServ.getenvConfig().subscribe((res) => {
                    if (res) {
                        this.configValue = res;
                        if( this.configValue && !this.router.url.includes('products')){
                              document.getElementById('keywordsMeta')?.setAttribute('content' , this.lang == 'ar' ? this.configValue.GLOBAL_KEYWORDS_AR_WEBSITE :  this.configValue.GLOBAL_KEYWORDS_EN_WEBSITE )
                        }
                    }
                });
            }
        });
        let url = window.location.pathname.split("/");
        let language = url[1];
        if (language === "en"){
            localStorage.setItem("lang", "en");
        }
        else if (language === "ar") {
            localStorage.setItem("lang", "ar");
        }
        else if(language === "") {
            const lang: string = localStorage.getItem('lang') ? localStorage.getItem('lang') as string : "en";
            localStorage.setItem("lang", lang);
        }
        else if (language != "en" && language != "ar") {
            if (!localStorage.getItem("lang"))
                localStorage.setItem("lang", "en");
            this.router.navigateByUrl(
                `${localStorage.getItem("lang")}${window.location.pathname}${
                    window.location.search
                }`
            );
        } 
        else {
            localStorage.setItem("lang", this.lang);
        }
        this.embryoService.emitLang.subscribe((lang: string) => {
            this.lang = lang;
            this.isRtl = lang == "en" ? "ltr" : "rtl";
            this.cdRef.detectChanges();
            this.translate.use(this.lang);
            this.translate.setDefaultLang(this.lang);
        });

        document.getElementById("html")?.classList.remove("admin-panel");
        document.getElementById("html")?.classList.add("user-end");
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            const sameAs = [];
            if (this.configValue.SOCIAL_URL_FACEBOOK) {
            sameAs.push(this.configValue.SOCIAL_URL_FACEBOOK);
            }
            if (this.configValue.SOCIAL_URL_FACEBOOK_2) {
            sameAs.push(this.configValue.SOCIAL_URL_FACEBOOK_2);
            }
            if (this.configValue.SOCIAL_URL_INSTAGRAM) {
            sameAs.push(this.configValue.SOCIAL_URL_INSTAGRAM);
            }
            if (this.configValue.SOCIAL_URL_INSTAGRAM_2) {
            sameAs.push(this.configValue.SOCIAL_URL_INSTAGRAM_2);
            }
            if (this.configValue.SOCIAL_URL_SNAPCHAT) {
            sameAs.push(this.configValue.SOCIAL_URL_SNAPCHAT);
            }
            if (this.configValue.SOCIAL_URL_SNAPCHAT_2) {
            sameAs.push(this.configValue.SOCIAL_URL_SNAPCHAT_2);
            }
            if (this.configValue.SOCIAL_URL_TWITTER) {
            sameAs.push(this.configValue.SOCIAL_URL_TWITTER);
            }
            if (this.configValue.SOCIAL_URL_TWITTER_2) {
            sameAs.push(this.configValue.SOCIAL_URL_TWITTER_2);
            }
            if (this.configValue.SOCIAL_URL_YOUTUBE) {
            sameAs.push(this.configValue.SOCIAL_URL_YOUTUBE);
            }
            if (this.configValue.SOCIAL_URL_YOUTUBE_2) {
            sameAs.push(this.configValue.SOCIAL_URL_YOUTUBE_2);
            }
            const script = document.createElement('script');
            script.type = 'application/ld+json';
            script.text = `
                    {
                    "@context": "https://schema.org",
                    "@type": "Organization",
                    "name":  "${this.configValue?.APP_NAME}",
                    "url": "${this.configValue.WEBSITE_URL}",
                    "logo":"${this.lang == 'ar' ? this.configValue.COLORED_LOGO_AR : this.configValue.COLORED_LOGO_EN}",
                    "contactPoint": {
                        "@type": "ContactPoint",
                        "telephone": "${this.configValue.HOTPHONE}",
                        "contactType": "customer service",
                        "contactOption": "HearingImpairedSupported",
                        "areaServed": "${this.configValue.COUNTRY_CODE}",
                        "availableLanguage": "${this.lang}"
                    },
                    "sameAs": ${JSON.stringify(sameAs)}
                    }
                `;
                document.body.appendChild(script);
        }, 2000);

        setTimeout(() => {
            const script = document.createElement('script');
            script.type = 'application/ld+json';
            script.text = `{
                                "@context": "https://schema.org/",
                                "@type": "WebSite",
                                "name":   "${this.configValue?.APP_NAME}",
                                "alternateName":"${this.configValue?.APP_NAME}",
                                "url": "${this.configValue?.WEBSITE_URL}"
                            }
                `;
                
            document.body.appendChild(script);

            if (this.lang == "en") {
                this.metaService.setTitle(
                    `${
                        this.configValue?.sloganEn ||
                        this.configValue?.APP_NAME
                    }`
                );
                this.metaService.setDescription(
                    `${this.configValue?.metaDescriptionEn ? this.configValue?.metaDescriptionEn   : 
                       `Shop for it at ${this.configValue?.WEBSITE_URL}. Shop Quality with direct Delivery or Pickup. It's now easier than ever to buy  it online from ${this.configValue?.WEBSITE_URL}`}`
                );
            } 
            else {
                this.metaService.setTitle(
                    `${
                        this.configValue?.sloganAr ||
                        this.configValue?.APP_NAME_AR
                    }`
                );
                this.metaService.setDescription(
                    `${this.configValue?.metaDescriptionAr ? this.configValue?.metaDescriptionAr : 
                      `عِدْ إلى متجرنا على الإنترنت${this.configValue?.WEBSITE_URL}.وتسوّق بجودة عالية مع التوصيل المباشر أو الاستلام. أصبح الآن أسهل من أي وقتٍ مضى شراء ما تحتاجه عبر الإنترنت من${this.configValue?.WEBSITE_URL}`
                    }`
                );
            }
        }, 1000);

  
        setTimeout(() => {
            if(this.configValue?.enable_pop_up_ads_on_all_pages){
                this.getPopupAds();
            }
        }, 2000);
    }

    destroyFreshChat() {
        window.fcWidget?.user.clear();
        window.fcWidget?.destroy();
    }

    addToCart(sku: any) {
        alert(`${sku} to be added to cart`);
    }

    getDynamicMenuData() {
       
        this.homePageService.getMenuData().subscribe((res) => {
            if (res.data) {
                if (this.configValue?.ENABLE_STATIC_MENU) {
                    this.menuItems.level1 = this.Categories;
                }  else {
                    this.menuItems = res.data;
                }
                this.homePageService.setMenuData(res);
            }
        });
        
    }
    closeBothBranch() {
        this.show_both_source = false;
        if (this.user.branch) this.closeBranchesPopup();
    }
    backandclose(e: any) {
        if (e && this.configValue.PICKUP_DELIVERY_SOURCE_Backup == "both") {
            this.configValue.PICKUP_DELIVERY_SOURCE = "both";
            this.settingsServ.setenvConfig(this.configValue);
        }
    }

    getConfigration() {
        this.settingsServ.getConfigrationVariables().subscribe((res) => {
            if (res.code == 700) {
                this.configValue = res;
                this.settingsServ.setenvConfigOfflineApp(this.configValue);
                return;
            }
            this.configValue = res.data;
            if (this.configValue){
                this.configValue.GUEST_CAN_VIEW_PRICES_TRIGGER =
                    this.configValue.GUEST_CAN_VIEW_PRICES;
            }
            if (
                !this.configValue?.ENABLE_MULTI_INVENTORY &&
                this.configValue?.ENABLE_PROFILE_SET_AREA_FROM_MAP
            ) {
                this.configValue.ENABLE_PROFILE_SET_AREA_FROM_MAP = false;
            }
            if (this.configValue?.ENABLE_MULTI_INVENTORY) {
                if (this.configValue.PICKUP_DELIVERY_SOURCE) {
                    this.configValue.PICKUP_DELIVERY_SOURCE_Backup =
                        this.configValue.PICKUP_DELIVERY_SOURCE;
                }
                if (
                    !this.configValue.PICKUP_DELIVERY_SOURCE ||
                    this.configValue.PICKUP_DELIVERY_SOURCE == "area"
                ) {
                    this.configValue.PICKUP_DELIVERY_SOURCE = "area";
                }
                this.setPickupSource();
                if (this.configValue?.PICKUP_DELIVERY_SOURCE == "store") {
                    this.getAllStores();
                }
            }

            if (this.configValue?.localization) {
                if (!this.configValue.localization.phone_length) {
                    this.configValue.localization.phone_length = 100000;
                }
            }
            this.setManifest();
            if (this.configValue.googleTagManID)
                this.marketingService.initGTM(this.configValue.googleTagManID);
            if (this.configValue.FACEBOOK_CLIENT_ID) {
                var configValue = this.configValue;
                var e = document.createElement("script");
                e.src =
                    document.location.protocol +
                    "//connect.facebook.net/en_US/all.js";
                e.async = true;
                document.getElementsByTagName("head")[0].appendChild(e);
                window.fbAsyncInit = function () {
                    window.FB.init({
                        appId: configValue.FACEBOOK_CLIENT_ID,
                        oauth: true,
                        status: true, // check login status
                        cookie: true, // enable cookies to allow the server to access the session
                        xfbml: true, // parse XFBML
                    });
                };
            }
            if (this.configValue.fbPixelId) {
                this.marketingService.initFBPixel(this.configValue.fbPixelId);
            }
            if (this.configValue.fbPixelId_2) {
                this.marketingService.initFBPixel(this.configValue.fbPixelId_2);
            }
            if (this.configValue.fbPixelId_3) {
                this.marketingService.initFBPixel(this.configValue.fbPixelId_3);
            }

            if (this.configValue.tiktokPixelId)
                this.marketingService.initTiktokPixel(
                    this.configValue.tiktokPixelId
                );

            if (this.configValue.snapChatPixelId)
                this.marketingService.initSnapPixel(
                    this.configValue.snapChatPixelId
                );
            // if (this.configValue.criteoPixelId)
            //     this.marketingService.initCriteoq(
            //         this.configValue.snapChatPixelId
            //     );

             if (this.configValue.GOOGLE_CONVERSION_ID) {
            
              
                 this.marketingService.initGoogleFeature(
                     this.configValue.GOOGLE_CONVERSION_ID
                 );
                 this.marketingService.initGoogleConversion(
                    this.configValue.GOOGLE_CONVERSION_ID
                );
             }

            if (this.configValue.GOOGLE_ANALYTICS_ID){
                this.marketingService.initGoogleFeature(
                        this.configValue.GOOGLE_ANALYTICS_ID
                    );
                this.marketingService.initGoogleAnalytics(
                    this.configValue.GOOGLE_ANALYTICS_ID
                );
            }
       
            if (this.configValue.HOTJAR_ID)
                this.marketingService.initHotJar(this.configValue.HOTJAR_ID);
            if (
                this.configValue.GOOGLE_CLIENT_ID &&
                this.configValue.ENABLE_GOOGLE_SIGN_IN
            ) {
                this.marketingService.addMetaTags(
                    "google-signin-client_id",
                    this.configValue.GOOGLE_CLIENT_ID
                );
            }
            if (this.configValue.WEB_BRAND_COLOR) {
                this.marketingService.addMetaTags(
                    "theme-color",
                    this.configValue.WEB_BRAND_COLOR
                );
            }
            if (this.configValue.GOOGLE_DOMAIN_VERIFY) {
                this.marketingService.addMetaTags(
                    "google-site-verification",
                    this.configValue.GOOGLE_DOMAIN_VERIFY
                );
            }
            if (this.configValue.FACEBOOK_DOMAIN_VERIFY) {
                this.marketingService.addMetaTags(
                    "facebook-domain-verification",
                    this.configValue.FACEBOOK_DOMAIN_VERIFY
                );
            }
            if (this.configValue?.LOYALTY_PROVIDER == "gameBall") {
                this.gamBallInit();
            }
            this.configValue.enable_guest_checkout = false;
            this.setconfig(this.configValue);
        });
    }

    backToBoth() {
        this.configValue.PICKUP_DELIVERY_SOURCE = "both";
        this.show_both_source = true;
    }

    closearea(e: any) {
        if (e) {
            this.backToBoth();
        }
    }

    setManifest() {
        var manifestJSON = {
            name:
                this.lang == "en" && this.configValue
                    ? this.configValue.APP_NAME
                    : this.configValue.APP_NAME_AR,
            short_name:
                this.lang == "en" && this.configValue
                    ? this.configValue.APP_NAME
                    : this.configValue.APP_NAME_AR,
            theme_color: this.configValue?.WEB_BRAND_COLOR,
            background_color: this.configValue?.WEB_BRAND_COLOR,
            display: "standalone",
            scope: window.location.href,
            start_url: window.location.href,
            icons: [
                {
                    src: this.configValue.FAV_ICON,
                    sizes: "72x72",
                    type: "image/png",
                    purpose: "maskable any",
                },
                {
                    src: this.configValue.FAV_ICON,
                    sizes: "96x96",
                    type: "image/png",
                    purpose: "maskable any",
                },
                {
                    src: this.configValue.FAV_ICON,
                    sizes: "128x128",
                    type: "image/png",
                    purpose: "maskable any",
                },
                {
                    src: this.configValue.FAV_ICON,
                    sizes: "144x144",
                    type: "image/png",
                    purpose: "maskable any",
                },
                {
                    src: this.configValue.FAV_ICON,
                    sizes: "152x152",
                    type: "image/png",
                    purpose: "maskable any",
                },
                {
                    src: this.configValue.FAV_ICON,
                    sizes: "192x192",
                    type: "image/png",
                    purpose: "maskable any",
                },
                {
                    src: this.configValue.FAV_ICON,
                    sizes: "384x384",
                    type: "image/png",
                    purpose: "maskable any",
                },
                {
                    src: this.configValue.FAV_ICON,
                    sizes: "512x512",
                    type: "image/png",
                    purpose: "maskable any",
                },
            ],
        };
        const stringManifest = JSON.stringify(manifestJSON);
        const blob = new Blob([stringManifest], { type: "application/json" });
        const manifestURL = URL.createObjectURL(blob);
        (<HTMLAnchorElement>(
            document.querySelector("#my-manifest-placeholder")
        )).setAttribute("href", manifestURL);
    }

    maintain() {
        localStorage.removeItem("skip_maintenance");
        //
        window.location.href = window.location.href
            .replace("?skip_maintenance=1", "")
            .replace("?skip_maintenance=0", "");
    }
    setconfig(configData: any) {
        this.setMainData(configData);

        if (!configData?.MINIMUM_TOTAL_AMOUNT_FOR_CREATING_ORDER) {
            configData.can_checkout = true;
        }
        if (!configData?.GUEST_CAN_VIEW_PRICES) {
            this.embryoService.productCartSub.next([]);
        }
        this.settingsServ.setenvConfig(configData);

        /**
         * TODO
         * Implement ar in title
         */

        this.setColors();
        this.getHeaderList();
        this.subscription = this.reactivityService.storeObserver$.subscribe(
            (data: any) => {
                if (data && data?.loggedInUser) {
                    if (
                        (!location.href.includes("account") &&
                            !location.href.includes("checkout") &&
                            !location.href.includes("signin")) ||
                        location.href.includes("checkout/final-receipt")
                    ) {
                        // this.cloneLocalData();
                    }
                }
            }
        );
    }
    closeBranchesPopup() {
        this.hideMultiStoresArea = true;
        this.user["show_branch_input"] = false;
        this.auth.setUserDataEmit(this.user);
    }

    setColors() {
        this.configValue?.SCROLL_COLOR
            ? document.documentElement.style.setProperty(
                  "--scroll-background-color",
                  this.configValue?.SCROLL_COLOR
              )
            : document.documentElement.style.setProperty(
                  "--scroll-background-color",
                  this.configValue?.WEB_BRAND_COLOR
              );
        this.configValue?.LABEL_TEXT_COLOR
            ? document.documentElement.style.setProperty(
                  "--label-text-color",
                  this.configValue?.LABEL_TEXT_COLOR
              )
            : null;

        this.configValue?.SOFTBAR_BG_COLOR
            ? document.documentElement.style.setProperty(
                  "--soft-bar-background",
                  this.configValue?.SOFTBAR_BG_COLOR
              )
            : null;
        this.configValue?.ADD_TO_CART_TEXT_FONT_SIZE
            ? document.documentElement.style.setProperty(
                  "--add-to-cart-text-size",
                  this.configValue?.ADD_TO_CART_TEXT_FONT_SIZE
              )
            : null;
        this.configValue?.SOFTBAR_FONT_COLOR
            ? document.documentElement.style.setProperty(
                  "--soft-bar-text-color",
                  this.configValue?.SOFTBAR_FONT_COLOR
              )
            : null;
        this.configValue?.WEB_BRAND_COLOR
            ? document.documentElement.style.setProperty(
                  "--brand-color",
                  this.configValue?.WEB_BRAND_COLOR
              )
            : null;
        this.configValue?.WEB_BRAND_COLOR
            ? document.documentElement.style.setProperty(
                  "--brand-color-opacity",
                  this.configValue?.WEB_BRAND_COLOR + "45"
              )
            : null;
        this.configValue?.WEB_FOOTER_BG_COLOR
            ? document.documentElement.style.setProperty(
                  "--footer-background",
                  this.configValue?.WEB_FOOTER_BG_COLOR
              )
            : null;
        this.configValue?.WEB_FOOTER_FONT_COLOR
            ? document.documentElement.style.setProperty(
                  "--footer-color",
                  this.configValue?.WEB_FOOTER_FONT_COLOR
              )
            : null;
        document.documentElement.style.setProperty(
            "--footer-titles-color",
            this.configValue?.FOOTER_TITLES_COLOR
                ? this.configValue?.FOOTER_TITLES_COLOR
                : this.configValue?.WEB_BRAND_COLOR
        );
        document.documentElement.style.setProperty(
            "--footer-titles-separator-color",
            this.configValue?.FOOTER_TITLES_SEPARATOR_COLOR
                ? this.configValue?.FOOTER_TITLES_SEPARATOR_COLOR
                : this.configValue?.WEB_BRAND_COLOR
        );
        document.documentElement.style.setProperty(
            "--copyright-separator-color",
            this.configValue?.COPYRIGHT_SEPARATOR_COLOR
                ? this.configValue?.COPYRIGHT_SEPARATOR_COLOR
                : "white"
        );
        document.documentElement.style.setProperty(
            "--footer-input-background-color",
            this.configValue?.FOOTER_INPUT_BACKGROUND_COLOR
                ? this.configValue?.FOOTER_INPUT_BACKGROUND_COLOR
                : "transparent"
        );
        document.documentElement.style.setProperty(
            "--footer-input-color",
            this.configValue?.FOOTER_INPUT_CORLO
                ? this.configValue?.FOOTER_INPUT_CORLO
                : this.configValue?.WEB_FOOTER_FONT_COLOR
        );
   
        this.configValue?.WEB_SECOND_COLOR
            ? document.documentElement.style.setProperty(
                  "--second-color",
                  this.configValue?.WEB_SECOND_COLOR
              )
            : null;
        this.configValue?.SECOND_BTN_BG_COLOR
            ? document.documentElement.style.setProperty(
                  "--second-button-background-color",
                  this.configValue?.SECOND_BTN_BG_COLOR
              )
            : this.configValue?.WEB_SECOND_COLOR;
        this.configValue?.VIEW_ALL_TEXT_COLOR
            ? document.documentElement.style.setProperty(
                  "--view-all-text-color",
                  this.configValue?.VIEW_ALL_TEXT_COLOR
              )
            : null;
        this.configValue?.VIEW_ALL_BACKGROUND_COLOR
            ? document.documentElement.style.setProperty(
                  "--view-all-background-color",
                  this.configValue?.VIEW_ALL_BACKGROUND_COLOR
              )
            : null;
        this.configValue?.BUY_NOW_TEXT_COLOR
            ? document.documentElement.style.setProperty(
                "--buy-now-text-color",
                this.configValue?.BUY_NOW_TEXT_COLOR
            )
            : document.documentElement.style.setProperty(
                "--buy-now-text-color",
                this.configValue?.LABEL_TEXT_COLOR
            );
        this.configValue?.BUY_NOW_BACKGROUND_COLOR
            ? document.documentElement.style.setProperty(
                "--buy-now-background-color",
                this.configValue?.BUY_NOW_BACKGROUND_COLOR
            )
            : document.documentElement.style.setProperty(
                "--buy-now-background-color",
                this.configValue?.LABEL_COLOR
            );

        this.configValue?.PRODUCT_PRICE_TEXT_COLOR
            ? document.documentElement.style.setProperty(
                  "--product-price-color",
                  this.configValue?.PRODUCT_PRICE_TEXT_COLOR
              )
            : "#000";
        this.configValue?.PRODUCT_PRICE_BEFORE_DISCOUNT_TEXT_COLOR
            ? document.documentElement.style.setProperty(
                  "--product-price-color-before-discount",
                  this.configValue?.PRODUCT_PRICE_BEFORE_DISCOUNT_TEXT_COLOR
              )
            : "#000";
        this.configValue?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR
            ? document.documentElement.style.setProperty(
                  "--product-price-color-after-discount",
                  this.configValue?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR
              )
            : "#000";
        this.configValue?.LOADING_SHIMMER_DARK_1
            ? document.documentElement.style.setProperty(
                  "--dark-gradient-1",
                  this.configValue?.LOADING_SHIMMER_DARK_1
              )
            : null;
        this.configValue?.LOADING_SHIMMER_DARK_2
            ? document.documentElement.style.setProperty(
                  "--dark-gradient-2",
                  this.configValue?.LOADING_SHIMMER_DARK_2
              )
            : null;
        this.configValue?.LOADING_SHIMMER_DARK_3
            ? document.documentElement.style.setProperty(
                  "--dark-gradient-3",
                  this.configValue?.LOADING_SHIMMER_DARK_3
              )
            : null;
 
        this.configValue?.LOADING_SHIMMER_LIGHT_1
            ? document.documentElement.style.setProperty(
                  "--light-graident-1",
                  this.configValue?.LOADING_SHIMMER_LIGHT_1
              )
            : null;
        this.configValue?.LOADING_SHIMMER_LIGHT_2
            ? document.documentElement.style.setProperty(
                  "--light-graident-2",
                  this.configValue?.LOADING_SHIMMER_LIGHT_2
              )
            : null;
        this.configValue?.TEXT_SIZE
            ? document.documentElement.style.setProperty(
                  "--text-size",
                  this.configValue?.TEXT_SIZE
              )
            : null;

        this.configValue?.FONT_FAMILY_AR
            ? document.documentElement.style.setProperty(
                  "--font-family-ar",
                  this.configValue?.FONT_FAMILY_AR
              )
            : "Cairo";
        this.configValue?.FONT_FAMILY_EN
            ? document.documentElement.style.setProperty(
                  "--font-family-en",
                  this.configValue?.FONT_FAMILY_EN
              )
            : "ProximaNovaSoft";
        this.configValue?.LABEL_COLOR
            ? document.documentElement.style.setProperty(
                  "--label-color",
                  this.configValue?.LABEL_COLOR
              )
            : null;
        this.configValue?.PRODUCT_NAME_TEXT_COLOR
            ? document.documentElement.style.setProperty(
                  "--product-text-color",
                  this.configValue?.PRODUCT_NAME_TEXT_COLOR
              )
            : "#000";
        this.configValue?.HEADER_ICONS_BACKGROUND_COLOR
            ? document.documentElement.style.setProperty(
                  "--HeaderIconsBackgroundColor",
                  this.configValue?.HEADER_ICONS_BACKGROUND_COLOR || "#fff"
              )
            : "#fff";

        this.configValue?.HEADER_ICONS_FILL_COLOR
            ? document.documentElement.style.setProperty(
                  "--HeaderIconsFillColor",
                  this.configValue?.HEADER_ICONS_FILL_COLOR || "#fff"
              )
            : "#fff";
        this.configValue?.HEADER_TEXT_COLOR
            ? document.documentElement.style.setProperty(
                  "--HeaderTextColor",
                  this.configValue?.HEADER_TEXT_COLOR || "#000"
              )
            : "#000";
        this.configValue?.FILL_ICONS_COLOR_HOVER
            ? document.documentElement.style.setProperty(
                  "--header-icons-fill-hover-color",
                  this.configValue?.FILL_ICONS_COLOR_HOVER || this.configValue?.HEADER_ICONS_FILL_COLOR
              )
            : this.configValue?.HEADER_ICONS_FILL_COLOR;
        this.configValue?.HEADER_SEARCH_BACKGROUND_COLOR
            ? document.documentElement.style.setProperty(
                  "--header-search-background-color",
                  this.configValue?.HEADER_SEARCH_BACKGROUND_COLOR ||
                      "#e6e0e079"
              )
            : "#e6e0e079";
        this.configValue?.HEADER_SEARCH_TEXT_COLOR
            ? document.documentElement.style.setProperty(
                  "--header-search-text-color",
                  this.configValue?.HEADER_SEARCH_TEXT_COLOR || "#000"
              )
            : "#000";
        this.configValue?.HEADER_SEPARATOR_COLOR
            ? document.documentElement.style.setProperty(
                  "--header-separator-color",
                  this.configValue?.HEADER_SEPARATOR_COLOR || "#e3e3e3"
              )
            : "#e3e3e3";
        this.configValue?.MENU_BUTTON_COLOR
            ? document.documentElement.style.setProperty(
                  "--menu-button-color",
                  this.configValue?.MENU_BUTTON_COLOR || "#e3e3e3"
              )
            : "#000";
        this.configValue?.MENU_BUTTON_BACKGROUND_COLOR
            ? document.documentElement.style.setProperty(
                  "--menu-button-background-color",
                  this.configValue?.MENU_BUTTON_BACKGROUND_COLOR || "#e6e0e079"
              )
            : "#e6e0e079";
        this.configValue?.CATEGORIES_COUNT_IN_ROW
            ? document.documentElement.style.setProperty(
                  "--categories-count-in-row",
                  this.configValue?.CATEGORIES_COUNT_IN_ROW.slice(0, 1) || "8"
              )
            : "8";
        !this.configValue?.ENABLE_SUBMENU_TEXT_TRANSFORMER_UPPERCASE
            ? document.documentElement.style.setProperty(
                  "--menu-transformer",
                  "initial"
              )
            : null;
    }

    setMainData(environmentVariables: any) {
        if (environmentVariables && environmentVariables?.FAV_ICON) {
            let oldLink = document.getElementById("dynamic-favicon");
            var link = document.createElement("link");
            link.rel = "icon";
            var pattern = new RegExp(
                "^(https?:\\/\\/)?" + // protocol
                    "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
                    "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
                    "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
                    "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
                    "(\\#[-a-z\\d_]*)?$",
                "i"
            ); // fragment locator
            link.href =
                environmentVariables?.FAV_ICON ||
                environment.api + "/storage/uploads/fav_icon.png";

            link.type = "image/x-icon";
            if (oldLink) {
                document.head.removeChild(oldLink);
            }
            document.getElementsByTagName("head")[0].appendChild(link);
            // var Oldlink: any = document.querySelector("link[rel~='icon']");
            // document.getElementsByTagName("head")[0].removeChild(Oldlink);
        }
        this.metaService.addTag({
            property: "og:title",
            content:
                this.lang == "en"
                    ? environmentVariables?.APP_NAME
                    : environmentVariables?.APP_NAME_AR,
        });
        this.metaService.addTag({
            property: "og:description",
            content:
                this.lang == "en"
                    ? environmentVariables?.footerAboutCompanyEn
                    : environmentVariables?.footerAboutCompanyAr,
        });
        this.metaService.addTag({
            property: "og:image",
            content:
                this.lang == "en" && this.configValue
                    ? this.configValue.COLORED_LOGO_EN
                    : this.configValue.COLORED_LOGO_AR,
        });
        this.metaService.addTag({
            property: "og:image:url",
            content:
                this.lang == "en" && this.configValue
                    ? this.configValue.COLORED_LOGO_EN
                    : this.configValue.COLORED_LOGO_AR,
        });
        this.metaService.addTag({
            property: "og:image:type",
            content: "image/png",
        });

        this.lang == "en"
            ? this.metaService.setTitle(environmentVariables?.APP_NAME)
            : this.metaService.setTitle(environmentVariables?.APP_NAME_AR);

        this.title.setTitle(
            environmentVariables?.sloganEn ||
                environmentVariables?.APP_NAME ||
                ""
        );
    }

    // Shows and hides the loading spinner during RouterEvent changes
    navigationInterceptor(event: RouterEvent): void {
        let vistorId  =   localStorage.getItem('vistorId')
          if(!vistorId){
            this.generateUserId()
          }
      
        if (event instanceof NavigationStart) {
            this.loadingRoute = true;
            // if( window.location.href.includes("not-found")){
            //     document.getElementById("Index-Follow")?.setAttribute('content' , "")
            // }else{
            //     document.getElementById("Index-Follow")?.setAttribute('content' , "INDEX,FOLLOW")
            // }
        }

        if (
            event instanceof NavigationEnd ||
            event instanceof NavigationCancel ||
            event instanceof NavigationError
        ) {
            this.loadingRoute = false;
        }

        let link: any = document.querySelector("link[rel='canonical']");
        link.setAttribute('href', `${window.location.href}`);
    }

     generateUserId() {
    // Use a library like uuid to generate a random UUID
    // Here's an example using the uuid library:
    // import { v4 as uuidv4 } from 'uuid';
    // return uuidv4();
    localStorage.setItem('vistorId' , Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15))
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  }


    ngOnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
    }

    verifyPhone() {
        if (!this.gmloading) {
            this.gmloading = true;
            this.account.sendVerficationMessage().subscribe(
                (res) => {
                    this.dialog.open(AddEditPhoneAndVerifyComponent, {
                        width: "400px",
                        data: {
                            phone: false,
                            add_loyalty_phone: true,
                            gameball: true,
                        },
                    });
                    this.gmloading = false;
                },
                (err) => (this.gmloading = false)
            );
        }
    }

    async gamBallInit() {
        const script = document.createElement("script");
        script.src =
            "https://assets.gameball.co/widget/js/gameball-init.min.js";
        const body = document.getElementsByTagName("body");
        body[0].appendChild(script);

        const userData = localStorage.getItem("auth_user_crocs");
        if (
            userData &&
            (JSON.parse(userData)?.phone == null ||
                JSON.parse(userData)?.phone == "")
        ) {
            const body = document.querySelector("body");
            if (body) {
                body.className = "noPhoneData";
            }
        } else {
            if (userData && JSON.parse(userData).phone_verified != 1) {
                const body = document.querySelector("body");
                if (body) {
                    body.className = "notVerifiedPhone";
                }
                var gameball = {
                    playerUniqueId: "",
                    dokkan: true,
                    playerAttributes: {},
                    lang: localStorage.getItem("lang"),
                    APIKey: "345e092baf4e46b6ad323001be6f7c09",
                    custom: { class: "E2022", weight: 78 },
                };
                if (window.GbLoadInit) {
                    await (GbSdk as any).init(gameball);
                } else {
                    await this.InitialGb(gameball);
                }
            } else {
                await gameBallInit();
            }
        }
    }

    InitialGb(gameball: any) {
        window.GbLoadInit = function () {
            GbSdk.init(gameball);
        };
    }

    getHeaderList(initilize?: any) {
         this.loading = true;
        var initalizePrams: any = {};
        initalizePrams["query_params"] = { ...this.route.snapshot.queryParams };
        if (!this.initilaizeData || initilize) {
            this.homePageService
                .getInitializationsData(initalizePrams)
                .subscribe((res: any) => {
                     if (res.code == 200 || res.code == 201) { 
                        initalizePrams = {};
                        this.utm_campaign = null;
                        this.router.navigate([], {
                            queryParams: {
                              'utm_campaign': null,
                            },
                            queryParamsHandling: 'merge'
                          })
                        if (res && res.data) {
                            if (res.data.cl_id) {
                                localStorage.setItem("cl_id", res.data.cl_id);
                            }
                            this.initilaizeData = res.data;
                            if (this.initilaizeData.last_order_id) {
                                this.getOrderById(
                                    this.initilaizeData.last_order_id
                                );
                            }
                              if(this.homePageService.environmentVariables.ENABLE_HIDE_CATEGORIES_WITHOUT_PRODUCTS_IN_STATIC_MENU) {
                                this.getCategoriesWithProductsStock()
                              } else  {
                                this.homePageService.categoriesDataSub.next(
                                    res.data?.categories
                                );
                                this.Categories = res.data?.categories;
                              }
                            this.compareList = res.data?.compare;
                           
                            this.embryoService.notificationsListSub.next({
                                notifications: res.data?.notifications,
                                unreadNotifications:
                                    res.data?.unreadNotifications,
                            });
                            // if (!this.auth.isGuest()) {
                            this.productList = res.data?.cart;
                            this.compareList = res.data?.compare;

                            // if (!this.canCloneGuestData) {
                            this.embryoService.productCartSub.next(
                                res.data?.cart
                            );
                            this.embryoService.compareListSub.next(
                                res.data?.compare
                            );
                            this.embryoService.favouritesListSub.next(
                                res.data?.favourites
                            );
                            this.embryoService.multiInventoryMap.next(
                                res.data?.profile
                            );
                            // }
                            if (!initilize) {
                                this.auth.setUserDataEmit(res.data?.profile);
                                this.auth.userEmit.next(res.data?.profile);
                                // handle this case
                                this.auth.setToken(res.data?.profile.token)
                            }

                            localStorage.setItem(
                                "auth_user_crocs",
                                JSON.stringify(res.data?.profile)
                            );
                            this.loading = false;
                            this.canCloneGuestData = false;
                            this.account.googleAnalaticsUserData = {
                                loginState: "logged-in",
                                userId: res.data?.profile?.id,
                                firstName: res.data?.profile?.name,
                                lastName: res.data?.profile?.last_name,
                                email: res.data?.profile?.email,
                                phoneNumber: res.data?.profile?.phone,
                                country: "eg",
                                city: res.data?.profile?.primary_address
                                    ? res.data?.profile?.primary_address.city
                                          ?.name
                                    : ""
                                    ? res.data?.profile?.primary_address.city
                                          ?.name
                                    : "",
                            };

                            // }
                            this.homePageService.setInitData(
                                this.initilaizeData
                            );
                        }
                        if (!initilize) {
                          // if ((this.configValue?.ENABLE_MULTI_INVENTORY && this.configValue?.PICKUP_DELIVERY_SOURCE_Backup == 'both' && (this.user?.branch || this.user?.area)) ||  ) 
                          if((!this.configValue?.ENABLE_STATIC_MENU && !this.configValue?.ENABLE_MULTI_INVENTORY)
                             || 
                            (this.configValue?.ENABLE_MULTI_INVENTORY &&
                              ( this.configValue?.PICKUP_DELIVERY_SOURCE_Backup == 'both' || this.configValue?.PICKUP_DELIVERY_SOURCE_Backup == 'area')
                               && 
                            (this.user?.branch || this.user?.area) )
                          ){
                            // this.getDynamicMenuData();
                        }
                        this.getDynamicMenuData();
                        }

                        if (this.configValue) {
                            if (this.configValue?.localization) {
                                if (
                                    !this.configValue.localization.phone_length
                                ) {
                                    this.configValue.localization.phone_length = 100000;
                                }
                            }
                            this.setconfig(this.configValue);
                            this.configValue.localization =
                                this.initilaizeData?.localization;
                            if (this.configValue?.localization) {
                                if (
                                    !this.configValue.localization.phone_length
                                ) {
                                    this.configValue.localization.phone_length = 100000;
                                }
                            }
                        } else {
                            setTimeout(() => {
                                this.configValue.localization =
                                    this.initilaizeData?.localization;
                                this.setconfig(this.configValue);
                            }, 1000);
                        }
                    }
                });
        }
    }

    getCategoriesWithProductsStock(){
       this.homePageService.getCategoriesWithProductsStock().subscribe((res:any) => {
        if(res.code === 200) {
            this.homePageService.categoriesDataSub.next(res.data);
            this.Categories = res.data;
            this.menuItems.level1 = res.data
        }
        })
     }

    cloneLocalData() {
        const guestProducts = {
            compare:
                localStorage.getItem("compareItems") &&
                localStorage.getItem("compareItems")?.length &&
                localStorage.getItem("compareItems") != "[]"
                    ? JSON.parse(<string>localStorage.getItem("compareItems"))
                    : [],
            favorites:
                localStorage.getItem("wishListItems") &&
                localStorage.getItem("wishListItems")?.length &&
                localStorage.getItem("wishListItems") != "[]"
                    ? JSON.parse(<string>localStorage.getItem("wishListItems"))
                    : [],
            cart:
                this.cartItems &&
                this.cartItems?.length &&
                this.cartItems?.length > 0 &&
                this.configValue?.GUEST_CAN_VIEW_PRICES
                    ? this.cartItems
                    : [],
        };

        this.canCloneGuestData = !!(
            guestProducts.compare.length ||
            guestProducts.favorites.length ||
            guestProducts.cart.length
        );

        if (this.canCloneGuestData && !this.loadingData) {
            this.loadingData = true;
            const guestProductsIds = {
                compare: guestProducts.compare.length
                    ? guestProducts.compare.map((item: any) => item.id)
                    : null,
                favourites: guestProducts.favorites.length
                    ? guestProducts.favorites.map((item: any) => item.id)
                    : null,
                cart: guestProducts.cart.length
                    ? {
                          reset: false,
                          items: guestProducts.cart.map((item: any) => {
                              return { id: item.id, amount: item.amount };
                          }),
                      }
                    : null,
            };

            this.homePageService
                .cloneGuestData(guestProductsIds)
                .subscribe((res: any) => {
                    this.loadingData = false;
                    if (res.code === 200) {
                        this.embryoService.productCartSub.next(res.data?.cart);
                        this.embryoService.compareListSub.next(
                            res.data?.compare
                        );
                        this.embryoService.favouritesListSub.next(
                            res.data?.favourites
                        );
                        this.embryoService.notificationsListSub.next({
                            notifications: res.data?.notifications,
                            unreadNotifications: res.data?.unreadNotifications,
                        });
                        localStorage.removeItem("wishListItems");
                        localStorage.removeItem("compareItems");
                    } else {
                        Swal.fire({
                            html: `<p style='color:white'>${res.message}</p>`,
                            width: 600,
                            position: "bottom-end",
                            background: "#fff",
                            timerProgressBar: true,
                            timer: 3000,
                            backdrop: false,
                            allowOutsideClick: true,
                        });
                        // this.toastr.error(res.message, "", {
                        //   timeOut: 3000,
                        //   progressBar: true,
                        //   progressAnimation: "increasing",
                        //   positionClass: 'toast-bottom-right'
                        // });
                    }
                });
        }
    }

    startTimer() {
        this.timer = 0;
        interval(1000)
            .pipe(
                take(3),
                tap((value) => (this.timer = value + 1))
            )
            .subscribe();
    }

    hideSideNav() {
        this.embryoService.sidenavOpen = false;
    }

    @HostListener("window:scroll", ["$event"])
    onScrollEvent($event: any) {
        $event.target.documentElement.scrollTop > 300
            ? (this.showBackToTop = true)
            : (this.showBackToTop = false);
    }

    scrollToTop() {
        const scrollDuration = 200;
        const scrollStep = -window.pageYOffset / (scrollDuration / 20);
        const scrollInterval: any = setInterval(
            () =>
                window.pageYOffset !== 0
                    ? window.scrollBy(0, scrollStep)
                    : clearInterval(scrollInterval),
            10
        );
        if (window.innerWidth <= 768) window.scrollTo(0, 0);
    }

    onActivate(e: any) {
        window.scroll(0, 0);
    }

    SkipRateing() {
        this.showOrderRate = false;
    }

    RateOrder() {
    }

    floatingBannerRouting(index: number) {
        const floatingBanner = this.homePageDataCustomAds[index];
        if (floatingBanner.item_data) {
            floatingBanner.nameRouter = encodeURIComponent(
                floatingBanner.item_data.name_en.replace(/\s/g, "-")
            );
        }
        
        const type = floatingBanner.type;
        if (type === 0) {
            return;
        }
        else if (type === 1) {
            this.router.navigateByUrl(
                `/${this.lang}/products/${this.homePageDataCustomAds[index].link}`
            );
        }
    }
  
    getPopupAds() {
        this.homePageService.getHomePopupAdsData().subscribe((res: any) => {
            let popupImageIndex: any = localStorage.getItem('popupImageIndex');
            if (popupImageIndex === null ||  popupImageIndex >= res?.data?.length - 1) {
               // First time visiting the page, set the initial index to 0
               popupImageIndex = 0;
           } else if (popupImageIndex < res?.data?.length - 1) {
                    popupImageIndex = Number(++popupImageIndex); // Convert the index from string to number and Increment the index
                }          
           localStorage.setItem('popupImageIndex', popupImageIndex.toString()); // Save the updated index
           res.data?.length > 0 ? this.viewAdsPopup(res.data) : '';
        });
    }

    viewAdsPopup(data: any) {
        let dialogRef:any;
        dialogRef = this.dialog.open(ViewAdsPopupComponent, { panelClass: 'custom-dialog-container' ,
            data: data,
        });
        dialogRef.afterClosed().subscribe();
    }
    showRouterOutlet(){
        if(this.hasStaticPage){
            return true
        }else { 
         const returnStatus = !this.configValue?.ENABLE_MULTI_INVENTORY ||
            (this.configValue?.ENABLE_MULTI_INVENTORY &&
               (this.configValue?.PICKUP_DELIVERY_SOURCE_Backup ==
                    'both' || this.configValue?.PICKUP_DELIVERY_SOURCE_Backup == 'area') 
                    &&
                (this.user?.branch || this.user?.area))
            return returnStatus
        }
    }
    checkMultiInventoryShow(){
        if(this.hasStaticPage){
            return false
        }else { 
         const returnStatus = this.initilaizeData &&
         !this.show_both_source &&

         this.configValue?.ENABLE_MULTI_INVENTORY &&
         this.configValue?.PICKUP_DELIVERY_SOURCE == 'area' &&
         (!this.user?.area || !this.user?.area?.available || this.user?.show_area_input)
            return returnStatus
        } 
    }
    checkStoreAreaShow(){
        if(this.hasStaticPage){
            return false
        }else { 
         const returnStatus =
          this.initilaizeData &&
         !this.show_both_source &&
         this.configValue?.ENABLE_MULTI_INVENTORY &&
         ((this.configValue?.PICKUP_DELIVERY_SOURCE == 'store' &&
             !this.user?.branch &&
             !this.hideMultiStoresArea) ||
             this.user?.show_branch_input)
            return returnStatus
        } 
    }
}
